import FourOhFour from './404';

export default FourOhFour;
